import { render, staticRenderFns } from "./RealtimeDataManager.vue?vue&type=template&id=7bf21b05&"
import script from "./RealtimeDataManager.vue?vue&type=script&lang=js&"
export * from "./RealtimeDataManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports